<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import firebase from 'firebase/compat/app';
import LoginComponent from '@/components/Auth/Login';
import axios from 'axios';
import SignupComponent from '@/components/Auth/Signup';
const uuid = require('uuid');
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
} from 'firebase/storage';

export default {
  metaInfo: {
    title: 'AddItem',
    titleTemplate: 'Strapp - New Item ➕',
    content:
      'An online rental marketplace where you can rent out your household items and equipment to others for short term periods.',
    htmlAttrs: { lang: 'en' },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },

  components: {
    // Register: () => import('./Register.vue'),
    LoginComponent,
    SignupComponent,
    vueDropzone: vue2Dropzone,
  },

  data() {
    return {
      state: 'add-item-auth',
      condition: null,
      event: '',
      loginDialog: false,
      continueAddItemAfterLogin: false,
      focus: '',
      signupDialog: false,
      addItem: false,
      welcomeDialog: false,
      period: 'Day(s)',
      // userstate: false,
      enabledDeposit: false,
      enabledDelivery: false,
      recomendedWeekly: '00',
      recomendedMonthly: '00',
      checkbox: false,
      successDialog: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Be more descriptive.',
        emailMatch: () => "The email and password you entered don't match",
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      periodLength: '1',
      custom: true,
      max: 500,
      minDays: 0,
      e4: 1,
      dialog: false,
      serialNumber: '',
      allCategories: [
        'Technology',
        'Transportation',
        'Household living',
        'DIY',
        'Exercise',
        'Music and Audio',
      ],
      allConditions: [
        'Like New, no signs of use',
        'Good, Minor signs of use, everything works',
        'Fair, Medium signs of use, everything works',
        'Worn, Heavy signs of use, everything works',
      ],
      periodOptions: ['Day(s)', 'Week(s)', 'Month(s)'],
      category: null,
      area: '',
      itemName: '',
      location: '',
      city: '',
      dailyFee: '',
      weeklyFee: '',
      monthlyFee: '',
      currentValue: '',
      // bookingStatus: 'Not Booked',
      enabled1: '',
      deposit: '',
      imageUrls: [],
      itemDescription: '',
      images: [],
      deliveryFee: '',
      delivery: '',
      savedLocations: [],
      formData: {
        street: '',
        city: '',
        state: '',
        zip: '',
      },
      showLoadingForCreateItem: false,
      isLoading: false,
      uploaded: 0,
      menuItems() {
        let menuItems = [
          { icon: 'fas fa-user-plus', title: 'Sign up', link: '/register' },
          { icon: 'fas fa-unlock', title: 'Sign in', link: '/login' },
        ];
        if (this.userIsAuthenticated) {
          menuItems = [
            // {
            //   icon: 'fas fa-tachometer-alt',
            //   title: 'Dashboard',
            //   link: '/profile'
            // }
          ];
        }
        return menuItems;
      },
    };
  },
  // async beforeMount() {
  //   const snap = await db.collection("locations").get();

  //   snap.docs.forEach(doc => {
  //     this.savedLocations.push(doc.data());
  //   });
  // },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
      e;
    },
    formIsValid() {
      return this.itemName.length > 5 && this.uploaded !== 0;
    },
    formIsValid1() {
      return (
        this.category !== null &&
        this.itemDescription.length > 50 &&
        this.condition !== null
      );
    },
    formIsValid2() {
      return (
        (this.currentValue !== '' && this.dailyFee !== '') ||
        this.weeklyFee !== '' ||
        this.monthlyFee !== ''
      );
    },
    formIsValid3() {
      return (
        (this.location.length == 4 &&
          this.area !== '' &&
          this.periodLength !== '' &&
          this.minPeriod !== '' &&
          this.period === 'Days') ||
        'Weeks' ||
        'Months'
      );
    },
    nameProgress() {
      return Math.min(100, this.itemName.length * 10);
    },
    nameColor() {
      return ['error', 'warning', 'success'][
        Math.floor(this.nameProgress / 30)
      ];
    },
    progress() {
      return Math.min(100, this.itemDescription.length * 1.6);
    },
    color() {
      return ['red', 'orange', 'green'][Math.floor(this.progress / 40)];
    },

    // enabledDeposit() {
    //   return (this.deposit = "00");
    // }
  },

  // mounted() {
  //   var autocomplete = new google.maps.places.Autocomplete(
  //     this.$refs['autocomplete'],
  //     {
  //       bounds: new google.maps.LatLngBounds(
  //         new google.maps.LatLng(45.4215296, -75.6971931)
  //       ),
  //     }
  //   );

  //   autocomplete.addListener('place_changed', () => {
  //     var place = autocomplete.getPlace();

  //     this.showLocationOnTheMap(
  //       place.geometry.location.lat(),
  //       place.geometry.location.lng()
  //     );
  //   });
  // },

  watch: {
    dailyFee: function (val) {
      // if daily fee === 00
      this.dailyFee = val;
      this.recomendedWeekly = val * 4;
      this.recomendedMonthly = val * 12;
    },
    enabledDeposit: function () {
      this.enabledDeposit = 'false';
      this.deposit = '';
    },
    // deposit: function() {
    //   this.deposit !== "'00'";
    //   this.enabled = "true";
    // },

    user(value) {
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          this.$router.push('/dashboard');
          this.$emit('loggedIn');
        } else if (this.addItem) {
          this.welcomeDialog = true;
          this.$emit('loggedIn');
          this.$router.push({ name: 'Onboarding', params: { addItem: true } });
        } else {
          this.$emit('loggedIn');
        }
      }
      if (value != null && this.continueAddItemAfterLogin) {
        this.onCreateItem();
      }
    },
  },
  methods: {
    initMarker(loc) {
      console.log(loc);
      console.log('location: ', loc);
      for (let i = 0; i < loc.address_components.length; i++) {
        if (loc.address_components[i].types[0] === 'locality') {
          this.city = loc.address_components[i].long_name;
        }
        if (loc.address_components[i].types[0] === 'postal_code') {
          this.location = loc.address_components[i].long_name;
        }
        if (
          loc.address_components[i].types[0] === 'sublocality_level_2' ||
          loc.address_components[i].types[0] === 'sublocality_level_1' ||
          loc.address_components[i].types[0] === 'sublocality'
        ) {
          this.area = loc.address_components[i].long_name;
        }
      }
    },

    dashboard() {
      this.$router.push('/dashboard');
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    stop() {
      this.$confetti.stop;
      this.$router.push('/dashboard');
    },
    uploadImageAndContinue() {
      this.e4 = 2;
      var files = this.$refs.imgDropZone.getAcceptedFiles();
      var arr = [];
      for (var i in files) {
        arr.push(files[i].dataURL);
      }
      this.imageUrls = arr;
    },
    async uploadImagesAndGetUrls() {
      return new Promise(async (resolve, reject) => {
        // const promises = [];
        var photos = [];
        for (var i in this.imageUrls) {
          var imageUrl = uuid.v1();
          try {
            // save image
            const file = this.imageUrls[i];
            // var metadata = {
            //   contentType: 'image/png',
            // };
            const storage = getStorage();
            const imageRef = ref(storage, `items/${imageUrl}.png`);

            // const snapshot = await uploadString(imageRef, file, metadata);
            const snapshot = await uploadString(imageRef, file, 'data_url');
            const downloadURL = await getDownloadURL(snapshot.ref);
            photos.push({ src: downloadURL });
            // promises.push(
            //   uploadBytes(imageRef, file, metadata).then((uploadResult) => {
            //     return getDownloadURL(uploadResult.ref);
            //   })
            // );

            // const photos = await Promise.all(promises);

            // console.log(photos);

            // await updateDoc(docRef, { photosURLs: photos });

            // await imageRef.putString(this.imageUrls[i], 'data_url');
            // var downloadURL = await getDownloadURL(
            //   uploadTask.snapshot.ref
            // ).then((downloadURL) => {
            //   console.log('File available at', downloadURL);
            // });

            console.log(photos);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(photos);
        resolve(photos);
      });
    },

    // async getMinDays() {
    //   if (this.period === "Day(s)") this.minDays = periodLength * 1;
    //   if (this.period === "Week(s)") this.minDays = periodLength * 7;
    //   if (this.period === "Month(s)") this.minDays = periodLength * 30;
    //   return this.minDays;
    // },

    async onCreateItem() {
      if (!this.formIsValid3) {
        return;
      }
      if (!this.userIsAuthenticated()) {
        // TODO
        this.loginDialog = true;
        this.continueAddItemAfterLogin = true;
      } else {
        this.showLoadingForCreateItem = true;
        var images = await this.uploadImagesAndGetUrls();

        //check if all the required data is present

        const itemData = {
          itemName: this.itemName,
          location: this.location,
          city: this.city,
          deposit: this.deposit,
          period: this.period,
          delivery: this.delivery,
          deliveryFee: this.deliveryFee,
          itemDescription: this.itemDescription,
          dailyFee: this.dailyFee,
          monthlyFee: this.monthlyFee,
          weeklyFee: this.weeklyFee,
          area: this.area,
          images,
          condition: this.condition,
          currentValue: this.currentValue,
          category: this.category,
          serialNumber: this.serialNumber,
        };

        this.dialog = true;
        this.$store
          .dispatch('createItem', itemData)
          .then(() => {
            this.showLoadingForCreateItem = false;
            this.successDialog = true;
          })
          .catch((err) => {
            //handle error
            this.showLoadingForCreateItem = false;
          });
        // this.$confetti.start();
      }
    },

    async remove() {
      this.uploaded > 0 ? this.uploaded-- : (this.uploaded = 0);
    },
    // i need this to add to the item collection.
    async afterComplete(upload) {
      this.uploaded++;
      //var imageUrl = uuid.v1();
      this.isLoading = true;
      // try {
      //   // save image
      //   const file = this.imageUrls[0];
      //   var metadata = {
      //     contentType: "image/png",
      //   };
      //   var storageRef = firebase.storage().ref();
      //   var imageRef = storageRef.child(`items/${imageUrl}.png`);
      //   await imageRef.put(file, metadata);
      //   var downloadURL = await imageRef.getDownloadURL();
      //   this.images.push({ src: downloadURL });
      // } catch (error) {
      //   console.log(error);
      // }
      // this.$refs.imgDropZone.removeFile(upload)
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    userIsLogged() {
      if (!this.userIsAuthenticated) {
        return false;
      } else if (this.userIsAuthenticated) {
        return true;
      }
    },
    userIsNotAuthenticated() {
      return (
        this.$store.getters.user == null &&
        this.$store.getters.user == undefined
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      for (var i = 0; i < files.length; i++) {
        const filename = files[i].name;
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file!');
        }
        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.imageUrls.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[i]);
      }
      console.log(this.imageUrls);
    },
    onPickFile() {
      this.$refs.imgDropZone.click();
    },
  },
};
</script>

<template>
  <div>
    <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
      <v-card style="border-radius: 12px" class="mb-16" text>
        <v-stepper
          color="#F2F5F8"
          style="background-color: #ffffff00"
          v-model="e4"
          elevation="12"
        >
          <v-stepper-header color="secondary">
            <v-stepper-step color="secondary" step="1" :complete="e4 > 1">
              Step 1
            </v-stepper-step>

            <v-divider />

            <v-stepper-step color="secondary" step="2" :complete="e4 > 2">
              Step 2
            </v-stepper-step>

            <v-divider />

            <v-stepper-step color="secondary" step="3" :complete="e4 > 3">
              Step 3
            </v-stepper-step>
            <v-divider />

            <v-stepper-step color="secondary" step="4"> Step 4 </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <center>
                <p class="display-1 secondary--text font-weight-black">
                  Name your item
                </p>
              </center>
              <form @submit.prevent="onCreateItem">
                <v-row>
                  <v-col cols="12" md="8" offset-md="2">
                    <v-text-field
                      v-model="itemName"
                      label="Item Name"
                      hint="More than 6 characters"
                      persistent-hint
                      counter
                      name="name"
                      placeholder="Start typing..."
                      loading
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          :value="nameProgress"
                          :color="nameColor"
                          absolute
                          height="3"
                          width="50px"
                        ></v-progress-linear>
                      </template>
                    </v-text-field>
                    <!-- <v-text-field
                      v-model="itemName"
                      minlength="6"
                      hint="More than 6 characters"
                      persistent-hint
                      name="name"
                      color="rgb(34, 34, 34)"
                      counter
                      label="Item Name"
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          :value="nameProgress"
                          :color="nameColor"
                          absolute
                          height="7"
                        ></v-progress-linear>
                      </template>
                    </v-text-field> -->

                    <br />
                    <p class="center">
                      <b
                        >Upload Item Images below (At least 1, maximum of 5
                        Images)
                      </b>
                    </p>

                    <vue-dropzone
                      id="customdropzone"
                      ref="imgDropZone"
                      type="file"
                      accept="image/*"
                      :max-number-of-files="5"
                      style="border-radius: 12px !important"
                      :options="dropzoneOptions"
                      @vdropzone-complete="afterComplete"
                      @vdropzone-removed-file="remove"
                    />
                    <v-row class="mx-8">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="white--text ml-16 mb-3 ebtn"
                        :disabled="!formIsValid"
                        color="primary"
                        :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                        @click="uploadImageAndContinue()"
                      >
                        Next
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <center>
                <p class="display-1 secondary--text font-weight-bold">
                  Add a description
                </p>
              </center>
              <form @submit.prevent="onCreateItem">
                <v-col cols="12" md="6" offset-md="3">
                  <v-select
                    v-model="category"
                    :items="allCategories"
                    label="Select a Category"
                    class="round"
                    outlined
                    color="rgb(34, 34, 34)"
                  />

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-textarea
                        v-bind="attrs"
                        v-on="on"
                        v-model="itemDescription"
                        placeholder="Start typing..."
                        loading
                        color="rgb(34, 34, 34)"
                        type="text"
                        :maxlength="max"
                        required
                        outlined
                        hint="between 50 and 500 characters."
                        counter
                        class="round"
                      >
                        <!--     <div
                          class="input-group-addon"
                          v-text="(max - itemDescription.length)"
                        /> -->
                        <template v-slot:progress>
                          <v-progress-linear
                            :description="progress"
                            :color="color"
                            :value="progress"
                            absolute
                            height="7"
                          />
                        </template>
                        <template v-slot:label>
                          <div>Describe your Item</div>
                        </template>
                      </v-textarea>
                    </template>
                    <span>Minimum of 50 characters needed</span>
                  </v-tooltip>

                  <v-select
                    v-model="condition"
                    :items="allConditions"
                    label="Item Condition"
                    class="round"
                    outlined
                    color="rgb(34, 34, 34)"
                  />

                  <v-text-field
                    v-model="serialNumber"
                    label="Item Serial Number*"
                    class="round"
                    outlined
                    placeholder="Serial Number"
                  />
                  <p class="font-italic text-caption mt-n2">*If applicable</p>

                  <v-row class="mb-4 pr-3 pl-3">
                    <v-btn
                      :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                      class="ebtn"
                      elevation="8"
                      style="
                        text-decoration: underline;
                        text-decoration-thickness: 1.2px;
                      "
                      @click="e4 = 1"
                    >
                      Back
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn
                      :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                      class="ebtn"
                      color="primary"
                      :disabled="!formIsValid1"
                      @click="e4 = 3"
                      rounded
                    >
                      Next
                    </v-btn>
                  </v-row>
                </v-col>
              </form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <center>
                <p class="display-1 secondary--text font-weight-black">
                  Set your rental Fee
                </p>
              </center>
              <form @submit.prevent="onCreateItem">
                <v-row>
                  <v-col cols="12" md="6" offset-md="3">
                    <p>What is the current value of the item?</p>
                    <v-text-field
                      id="value"
                      v-model="currentValue"
                      v-on:keypress="isNumber(event)"
                      name="value"
                      label="Rand Value"
                      class="round"
                      suffix=".00"
                      maxlength="10"
                      outlined
                      prefix="R"
                      v-bind:focus="focus"
                      v-on:focus="focus = false"
                      required
                    />

                    <p>Set your rental prices</p>

                    <v-text-field
                      class="round"
                      v-model="dailyFee"
                      v-on:keypress="isNumber(event)"
                      name="value"
                      label="Daily"
                      suffix=".00"
                      outlined
                      maxlength="12"
                      v-bind:focus="focus"
                      v-on:focus="focus = false"
                      prefix="R"
                      required
                    />
                    <p
                      class="font-italic text-caption text-md-body-2 secondary--text"
                      v-if="dailyFee"
                      v-text="
                        '*Weekly Fee should\'nt exceed: R ' + recomendedWeekly
                      "
                    ></p>
                    <v-text-field
                      class="round"
                      v-model="weeklyFee"
                      label="Weekly Fee"
                      placeholder="00"
                      outlined
                      v-on:keypress="isNumber(event)"
                      maxlength="12"
                      :disabled="dailyFee == ''"
                      suffix=".00"
                      v-bind:focus="focus"
                      v-on:focus="focus = false"
                      prefix="R"
                      required
                    />
                    <p
                      class="font-italic text-caption text-md-body-2 secondary--text"
                      v-if="dailyFee"
                      v-text="
                        '*Monthly Fee should\'nt exceed: R ' + recomendedMonthly
                      "
                    ></p>
                    <v-text-field
                      class="round"
                      label="Monthly Fee"
                      placeholder="00"
                      label-style="font-weight: bold;"
                      v-model="monthlyFee"
                      v-bind:focus="focus"
                      v-on:keypress="isNumber(event)"
                      :disabled="dailyFee == ''"
                      v-on:focus="focus = false"
                      prefix="R"
                      required
                      maxlength="10"
                      suffix=".00"
                      outlined
                    />

                    <p>Do you require a deposit? (leave blank if none)</p>
                    <v-text-field
                      v-model="deposit"
                      label="Deposit Amount"
                      prefix="R"
                      required
                      v-on:keypress="isNumber(event)"
                      placeholder="00"
                      suffix=".00"
                      class="round"
                      outlined
                    />
                    <!-- </v-row> -->
                    <v-row class="mb-4 pr-5 pl-5">
                      <v-btn
                        rounded
                        :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                        elevation="8"
                        class="ebtn"
                        style="
                          text-decoration: underline;
                          text-decoration-thickness: 1.2px;
                        "
                        @click="e4 = 2"
                      >
                        Back
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="ebtn"
                        rounded
                        color="primary"
                        :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                        elevation="8"
                        :disabled="!formIsValid2"
                        @click="e4 = 4"
                      >
                        Next
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </form>
            </v-stepper-content>

            <v-stepper-content step="4">
              <center>
                <p class="display-1 secondary--text font-weight-black">
                  Add a location
                </p>
              </center>
              <!-- STEP 4 -->
              <form @submit.prevent="onCreateItem">
                <v-col cols="12" md="8" offset-md="2">
                  <v-row>
                    <!-- <v-switch
                      v-model="enabledDelivery"
                      color="primary"
                    ></v-switch> -->

                    <v-col>
                      <p>Delivery Fee: (leave blank if none)</p>
                      <v-text-field
                        v-model="deliveryFee"
                        v-on:keypress="isNumber(event)"
                        v-bind:focus="focus"
                        placeholder="00"
                        v-on:focus="focus = false"
                        prefix="R"
                        class="round"
                        outlined
                      />
                    </v-col>
                  </v-row>

                  <form @submit.prevent="handleFormSubmit">
                    <v-row>
                      <!-- <v-col cols="12" xs="12" sm="12" md="6">
                        <p>Postal Code:</p>
                        <v-text-field
                          v-model="location"
                          outlined
                          class="round"
                          v-on:keypress="isNumber(event)"
                          maxlength="4"
                          label="Postal Code"
                          prepend-icon="mdi-map-marker"
                          required
                        />
                      </v-col> -->

                      <v-col cols="12" xs="12" sm="12" md="12">
                        <p>Suburb:</p>
                        <gmap-autocomplete
                          class="gmap"
                          @place_changed="initMarker"
                        ></gmap-autocomplete>

                        <!-- <v-text-field
                          v-model="area"
                          outlined
                          class="round"
                          label=""
                          required
                        /> -->
                      </v-col>
                    </v-row>
                  </form>

                  <v-row class="ma-2">
                    <v-btn
                      :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                      class="ebtn"
                      text
                      style="
                        text-decoration: underline;
                        text-decoration-thickness: 1.2px;
                      "
                      elevation="8"
                      @click="e4 = 3"
                    >
                      Back
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      :disabled="!formIsValid3 || showLoadingForCreateItem"
                      class="ebtn"
                      :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                      type="submit"
                      rounded
                      color="accent"
                      elevation="8"
                      :loading="showLoadingForCreateItem"
                    >
                      Submit
                    </v-btn>
                  </v-row>
                </v-col>
              </form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-col>

    <v-overlay v-if="showLoadingForCreateItem">
      <v-img :src="require('@/assets/svgs/gondola2.svg')" />
      Uploading your item...
    </v-overlay>

    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1em !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <!-- <v-icon
                                  small
                                  color="black"
                                  @click="startDialog = false"
                                  >mdi-close</v-icon
                                > -->
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
          >
            Congrats on submitting your Item! We will let you know once someone
            requests to rent it out
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-btn
              block
              class="btn white--text"
              style="border-radius: 8px !important"
              @click="dashboard()"
              color="black"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="false"
        @loggedIn="signupDialog = false"
        :fromPage="false"
        :addItem="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      />
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="false"
        :addItem="true"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>
    <v-dialog
      style="border-radius: 12px !important"
      v-model="welcomeDialog"
      width="500"
    >
      <v-card style="border-radius: 12px !important" class="text-center">
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="welcomeDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Get Started</p>
        </v-card-title>
        <v-divider></v-divider>

        <base-img
          :src="require('@/assets/logos/icon1.svg')"
          class="mb-5 mt-15 mx-auto"
          contain
          height="100"
          width="382"
        />

        <p class="heading my-3 ml-auto mr-auto">Welcome to Strapp</p>
        <v-card-text
          style="
            font-size: 16px !important;
            line-height: 20px !important;
            color: rgb(34, 34, 34) !important;
          "
        >
          Experience new ways of participating with your community
        </v-card-text>
        <!-- <v-card-text>
          Users will not be able to see your photo until a booking has been
          made.
        </v-card-text> -->

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-btn
            v-if="addItem"
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="onCreateItem"
            color="black"
          >
            Finish Submitting Item
          </v-btn>

          <v-btn
            v-else
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="(verifyDialog = true), (startDialog = false)"
            color="black"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
/* TODO: set width for screen sizes  */
/* .dz-progess{

} */
.dropzone .dz-preview.dz-image-preview {
  background: white;
  z-index: 2;
  margin: 16px;
}

.round {
  border-radius: 12px !important;
}

.bbtn {
  display: inline-block;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  padding: 0.8rem 1.8rem;
  background: transparent !important;
  color: rgb(34, 34, 34) !important;
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  transition: 0.5s;
  transition: all 0.3s ease 0s;
}

.bbtn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 5px 10px #b83bf1;
  transform: translateY(-7px);
  color: #b83bf1;
  background-color: #b83bf1;
}

.ebtn {
  display: inline-block;
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  padding: 0.8rem 1.8rem;
  /* background: rgb(34, 34, 34) !important;
  color: rgb(255, 255, 255) !important; */
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  transition: 0.5s;
  transition: all 0.3s ease 0s;
}

.ebtn:hover {
  opacity: 0.8;
  border-radius: 18px;

  transform: translateY(-7px);
}

.grid {
  display: grid;
  place-items: center;
}

.cbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.cbutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.abutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.abutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}



.btn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #81abfc;
  background-color: #7552b9;
}

.gmap {
  background-color: white;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
}

@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
